function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.5 0.5H4.5C2.29086 0.5 0.5 2.29086 0.5 4.5V25.5C0.5 27.7091 2.29086 29.5 4.5 29.5H25.5C27.7091 29.5 29.5 27.7091 29.5 25.5V4.5C29.5 2.29086 27.7091 0.5 25.5 0.5Z",
  stroke: "#979797"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.5571 9.64628L21.2043 10.2419C21.9571 10.9347 21.9571 12.0579 21.2043 12.7507L11.6039 21.5856H8.23047V18.4812L17.8309 9.64628C18.5837 8.95352 19.8043 8.95352 20.5571 9.64628ZM16.664 10.7202L20.0373 13.8246L16.664 10.7202Z",
  stroke: "#979797",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgEditSquareBorder = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgEditSquareBorder, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit-square-border.4ac521cb.svg";
export { ForwardRef as ReactComponent };